import { render } from "./ContractPatient.vue?vue&type=template&id=1232b11a&scoped=true"
import script from "./ContractPatient.vue?vue&type=script&lang=js"
export * from "./ContractPatient.vue?vue&type=script&lang=js"

import "./ContractPatient.vue?vue&type=style&index=0&id=1232b11a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1232b11a"]])

export default __exports__